import { Type } from "@shared/ui/Type";
import { SupportRecommendedArticleGroup } from "./SupportRecommendedArticleGroup";
import { Category } from "../../support.types";

export type Props = {
  categories: Category[];
};

export function SupportRecommendedArticles({ categories }: Props) {
  // Filter out empty categories (no articles in them or their subcategories)
  const hasArticles = (category: Category): boolean => {
    return (
      category.articles.length > 0 ||
      category.subcategories.some((subcat) => hasArticles(subcat))
    );
  };

  const nonEmptyCategories = categories.filter(hasArticles);

  return (
    <div className="w-full flex flex-col gap-6 max-w-3xl px-4 md:px-0">
      <Type variant="h4">Recommended Articles</Type>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {nonEmptyCategories.map((category) => (
          <SupportRecommendedArticleGroup
            key={category.id}
            category={category}
          />
        ))}
      </div>
    </div>
  );
}

export default SupportRecommendedArticles;
